import type { IconSvgObject } from './types';

const LinkForwardIcon: IconSvgObject = [
  ["path", { d: "M13 8.5H13.5V4L21 11.5L13.5 19V14.5C7 14.5 3 20 3 20V18.5C3 12.9772 7.47715 8.5 13 8.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default LinkForwardIcon;
